module.exports = __webpack_public_path__ + "img/speaker-icon.988500e1.svg";